import { z } from "zod";
// Keep this aligned with the is_valid_email_address PostgreSQL function.
export const EmailAddressZ = z
    .string()
    .trim()
    .toLowerCase()
    .email({ pattern: z.regexes.html5Email });
export function isValidEmail(email) {
    const result = EmailAddressZ.safeParse(email);
    return result.success;
}
//# sourceMappingURL=isValidEmail.js.map